module.exports = __webpack_public_path__ + "assets/a-10-yiliaoxiang.7d280ada.svg";